/* Copyright (c) 2016-2023 Planticle Pty Ltd */
"use strict";

import util from "./util.js";

// ---- polygon clipping - start

// Fix orientation of polygon if necessary such that outer ring is
// clockwise and inner rings are anti-clockwise
function orientedPolygon(poly) {
  var path, paths;
  var i;
  var ok = true;

  paths = poly.getArray().map(function(path) {
    return path.getArray();
  });

  for(i = 0; i < paths.length; i++) {
    path = paths[i];
    if((i == 0 && !isClockwise(path)) ||
       (i > 0 && isClockwise(path))) {
      ok = false;
      path.reverse();
    }
  }

  return ok ? poly : new google.maps.Data.Polygon(paths);
}


// Test if a ring is clockwise
function isClockwise(ring) {
  var i, j, xi, yi, xj, yj, area = 0;

  if(ring.length == 0) {
    console.log("uh oh");
  }

  j = ring.length - 1;
  xj = ring[j].lng();
  yj = ring[j].lat();

  for(i = 0; i < ring.length; i++) {
    xi = ring[i].lng();
    yi = ring[i].lat();

    area +=  (xj * yi - xi * yj);

    j = i;
    xj = xi;
    yj = yi;
  }

  return area < 0;
}

function clipPolyToBounds(poly, bounds) {
  poly = orientedPolygon(poly);

  var sw = bounds.getSouthWest();
  var ne = bounds.getNorthEast();

  var edges = [
    {a: 1, b: 0, c: sw.lng()}, // W
    {a: 0, b: 1, c: sw.lat()}, // S
    {a: -1, b: 0, c: -ne.lng()}, // E
    {a: 0, b: -1, c: -ne.lat()}, // N
  ];

  var polys = [poly];
  edges.forEach(function(edges) {
    polys = polys.map(function(poly) {
      return clipPolyToLine(poly, edges.a, edges.b, edges.c);
    }).flat();
  });

  // re-orient after clip
  polys = polys.map(orientedPolygon);

  return polys;
}

function clipPolyToLine(poly, a, b, c) {
  var r, i, j, p, q, p_inside, q_inside, ring;
  var rings = poly.getArray();
  var ring_endpoints;
  var endpoints = [];
  var holes = [];

  // Find endpoints created by clipping
  for(r = 0; r < rings.length; r++) {
    ring = rings[r].getArray();
    ring_endpoints = [];

    p = ring[ring.length - 1];
    p_inside = a * p.lng() + b * p.lat() > c;
    for(i = 0; i < ring.length; i++) {
      q = ring[i];
      q_inside = a * q.lng() + b * q.lat() > c;
      if(p_inside != q_inside) {
        ring_endpoints.push({
          index: i,
          ring: ring,
          r: r, // DEBUG
          intersect: lineIntersection(p.lng(), p.lat(), q.lng(), q.lat(), a, b, c),
          entry: q_inside
        });
      }
      p = q;
      p_inside = q_inside;
    }

    if(ring_endpoints.length > 0) {
      // Link ring end points
      for(i = ring_endpoints[0].entry ? 0 : 1; i < ring_endpoints.length; i += 2) {
        j = (i + 1) % ring_endpoints.length;
        ring_endpoints[i].next = ring_endpoints[j];  
      }

      for(i = 0; i < ring_endpoints.length; i++) {
        endpoints.push(ring_endpoints[i]);
      }
    } else {
      // check for holes that are fully inside the clip area - these need to be added back in later
      if(p_inside && r > 0) {
        holes.push(rings[r]);
      }
    }
  }

  // Simplest cases - did not cross line
  if(endpoints.length == 0) {
    return p_inside ? [poly] : [];
  }

  // Sort endpoints
  endpoints = endpoints.toSorted(util.compareNumberFn(function(endpoint) {
    return endpoint.intersect[0] * b + endpoint.intersect[1] * a;
  }));

  // Finish endpoint linked list
  if(endpoints[0].entry) {
    endpoints.reverse();
  }
  for(i = 0; i < endpoints.length; i += 2) {
    j = (i + 1) % endpoints.length;
    endpoints[i].next = endpoints[j];
  }

  // Check that all endpoints are linked
  if(endpoints.some(function(endpoint) { return endpoint.next == null; })) {
    console.log(poly);
    console.log([a,b,c]);
    console.log(endpoints);
    throw "Endpoints not all linked";
  }

  // Process endpoints to build results
  rings = [];
  endpoints.forEach(function(endpoint) {
    if(endpoint.visited) return;

    var newRing = [];

    while(!endpoint.visited) {
      endpoint.visited = true;
      newRing.push(new google.maps.LatLng(endpoint.intersect[1], endpoint.intersect[0]));

      if(endpoint.entry) {
        pushWrappedRange(newRing, endpoint.ring, endpoint.index, endpoint.next.index);
      }
      endpoint = endpoint.next;
    }

    rings.push(newRing);
  });

  return rings.map(function(ring) {
    // note: not a Data.Polygon
    var poly = new google.maps.Polygon({paths: ring});

    // Add back holes
    var holesInside = [], holesOutside = [];
    holes.forEach(function(hole) {
      if(google.maps.geometry.poly.containsLocation(hole.getAt(0), poly)) {
        holesInside.push(hole);
      } else {
        holesOutside.push(hole);
      }
    });
    holes = holesOutside;

    if(holesInside.length > 0) {
      return new google.maps.Data.Polygon([ring].concat(holesInside));
    } else {
      return new google.maps.Data.Polygon([ring]);
    }
  });
}


function pushWrappedRange(dest, src, start, end) {
  var i;
  if(start <= end) {
    for(i = start; i < end; i++) dest.push(src[i]);
  } else {
    for(i = start; i < src.length; i++) dest.push(src[i]);
    for(i = 0; i < end; i++) dest.push(src[i]);
  }
}

// Intersect the line (x1 + t (x2-x1), y1 + t (y2 - y1)) with the line ax + by = c
function lineIntersection(x1, y1, x2, y2, a, b, c) {
  var t = (c - a * x1 - b * y1) / ( a * (x2 - x1) + b * (y2 - y1));
  return [
    x1 + t * (x2 - x1),
    y1 + t * (y2 - y1),
  ];
}

function clipLineStringToBounds(line, bounds) {
  var sw = bounds.getSouthWest();
  var ne = bounds.getNorthEast();

  var edges = [
    {a: 1, b: 0, c: sw.lng()}, // W
    {a: 0, b: 1, c: sw.lat()}, // S
    {a: -1, b: 0, c: -ne.lng()}, // E
    {a: 0, b: -1, c: -ne.lat()}, // N
  ];

  var lines = [line];
  edges.forEach(function(edges) {
    lines = lines.map(function(line) {
      return clipLineStringToLine(line, edges.a, edges.b, edges.c);
    }).flat();
  });

  return lines;
}

function clipLineStringToLine(line, a, b, c) {
  var i, p, q;
  var lines = [];
  var newLine;
  var p_inside, q_inside;

  line = line.getArray();

  if(line.length == 0) return [];

  p = line[0];
  p_inside = a * p.lng() + b * p.lat() > c;
  if(p_inside) {
    newLine = [p];
    lines.push(newLine);
  }
  for(i = 1; i < line.length; i++) {
    q = line[i];
    q_inside = a * q.lng() + b * q.lat() > c;
    if(p_inside == q_inside) {
      if(q_inside) {
        newLine.push(q);
      }
    } else {
      var intersect = lineIntersection(p.lng(), p.lat(), q.lng(), q.lat(), a, b, c);
      var r = new google.maps.LatLng(intersect[1], intersect[0]);
      if(q_inside) {
        newLine = [r, q];
        lines.push(newLine);
      } else {
        newLine.push(r);
      }
    }
    p = q;
    p_inside = q_inside;
  }

  return lines.map(function(l) {
    try {
      return new google.maps.Data.LineString(l);
    } catch(e) {
      console.log(e);
      console.log(line);
      console.log(lines);
      throw e;
    }
  });
}

export {
  clipPolyToBounds,
  clipLineStringToBounds,
  orientedPolygon
};

// --- test/DEBUG

// if(localStorage.runTests) {
//   testClip();
// }

function logPoly(poly) {
  console.log("poly:");
  poly.getArray().forEach(logRing);
}

function logRing(ring) {
  console.log("ring:");
  ring.getArray().forEach(logPoint);
}

function logPoint(p) {
  console.log(p.lng() + ", " + p.lat());
}

function testClip() {
  var ring = new google.maps.Data.LinearRing([
      { lng: 3, lat: 2 },
      { lng: 3, lat: -3 },
      { lng: -3, lat: -3 },
      { lng: -3, lat: -1 },
      { lng: 2, lat: -1 },
      { lng: 2, lat: 1 },
      { lng: -3, lat: 1 },
      { lng: -3, lat: 2 }
    ]);
  var bounds = new google.maps.LatLngBounds(
    new google.maps.LatLng(-2,-2),
    new google.maps.LatLng(3,1)
  );
  var poly = new google.maps.Data.Polygon([ring]);
  // var poly = new google.maps.Data.Polygon([
  //   new google.maps.Data.LinearRing([
  //     { lng: 0, lat: 6 },
  //     { lng: 6, lat: 0 },
  //     { lng: 0, lat: -6 },
  //     { lng: -6, lat: 0 }
  //   ]), new google.maps.Data.LinearRing([
  //     { lng: -5, lat: 0 },
  //     { lng: 0, lat: -5 },
  //     { lng: 5, lat: 0 },
  //     { lng: 0, lat: 5 }
  //   ])
  // ]);
  // var bounds = new google.maps.LatLngBounds(
  //   new google.maps.LatLng(-4,-4),
  //   new google.maps.LatLng(4,4)
  // );

  var clippedPolys = clipPolyToBounds(poly, bounds);

  console.log("result:");
  clippedPolys.forEach(logPoly);
}
